import {connect} from "react-redux";
import CompleteActivity from "./Complete";
import {bindActionCreators} from "redux";
import {documentUploadUrlPublic} from "../../../../service/fileUpload/action";
import {
    markAttendances,
    getActivity,
    userCheckout,
    activityTypes,
    newActivity,
    dealerById,
    getSenior,
    addTaggedAlong
} from "../../../../service/Dealer/action";
import {getJourney} from "../../../../service/Journey/action";
import {errorLogs} from "../../../../service/FasttagToll/action";

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    markAttendanceDetails: state.Dealer.markAttendance,
    getActivityDetails: state.Dealer.getActivity,
    isCheckoutDetails: state.Dealer.isCheckoutDetails,
    activityTypesDetails: state.Dealer.activityTypesDetails,
    NewActivityDetails: state.Dealer.saveNewActivity,
    addedTaggedAlong: state.Dealer.addedTaggedAlong,
    dealerByIdDetails: state.Dealer.dealerById,
    senior: state.Dealer.senior,
    getUserJourney: state.Journey.getUserJourney,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            markAttendances,
            getActivity,
            newActivity,
            userCheckout,
            activityTypes,
            dealerById,
            getSenior,
            addTaggedAlong,
            getJourney,
            errorLogs
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(CompleteActivity);
